<footer class="footer">
    <div class="footer-content">
      <p>App Version: {{ appVersion }} &copy; 2025 Solina. All rights reserved.</p>
    </div>
  </footer>